import { Element } from '../../../../common/html/element'
import { ApplyCriteria } from './ApplyCriteria'
import { CriteriaName } from './CriteriaName'
import classes from './index.module.scss'

export const Header = () => {
  return (
    <Element className={classes.header} style={{ borderColor: '#D5D5D5' }}>
      <CriteriaName />
      <ApplyCriteria />
    </Element>
  )
}
